import { render, staticRenderFns } from "./SearchEventsField.vue?vue&type=template&id=49840c7a&scoped=true&lang=pug"
import script from "./SearchEventsField.vue?vue&type=script&lang=js"
export * from "./SearchEventsField.vue?vue&type=script&lang=js"
import style0 from "./SearchEventsField.vue?vue&type=style&index=0&id=49840c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49840c7a",
  null
  
)

export default component.exports